import {DirectionConfig, ParticleEmitterConfig, Point2d, SpawnShape} from '@specials/particle-emitter';

export const CLICK_ENERGY = 1;

export const COMETA_MIN_SPEED = 3;
export const COMETA_MAX_SPEED = 6;

export const COMETA_CLICK_ENERGY = 10;
export const ASTEROID_CLICK_ENERGY = 20;
export const ASTEROID_HEALTH = 4;
export const ASTEROID_MIN_SPEED = 3;
export const ASTEROID_MAX_SPEED = 4.5;

export const BONUS_EMITTER_POOL_SIZE = 3;
export const BONUS_SIZE = 70;
export const BONUS_VIEWPORT_SAFE_ZONE = 250;
export const COMETA_SPAWN_MIN_TIME = 800;
export const COMETA_SPAWN_MAX_TIME = 5000;
export const ASTEROID_SPAWN_MIN_TIME = 10000;
export const ASTEROID_SPAWN_MAX_TIME = 24000;

export const VALUE_BONUS_SIZE = 100;

export enum GameObjectsTags {
  Bonus = 'Bonus',
  SpaceshipDataComponent = 'SpaceshipDataComponent',
  BackgroundDataComponent = 'BackgroundDataComponent',
}

// дальние звезды
export const BACKGROUND_FAR_STAR_SPEED = 0.2;
export const BACKGROUND_FAR_STAR_MIN_ALPHA = 0.25;
export const BACKGROUND_FAR_STAR_MAX_ALPHA = 1;
export const BACKGROUND_FAR_STAR_MIN_SIZE = 8;
export const BACKGROUND_FAR_STAR_MAX_SIZE = 11;
export const BACKGROUND_FAR_STAR_COUNT = 30;

// ближние звезды
export const BACKGROUND_NEAR_STAR_SPEED = 0.5;
export const BACKGROUND_NEAR_STAR_MIN_ALPHA = 0.8;
export const BACKGROUND_NEAR_STAR_MAX_ALPHA = 1;
export const BACKGROUND_NEAR_STAR_MIN_SIZE = 15;
export const BACKGROUND_NEAR_STAR_MAX_SIZE = 20;
export const BACKGROUND_NEAR_STAR_COUNT = 10;

// мерцающие звезды
export const BACKGROUND_PULSAR_COUNT = 10;

export const BACKGROUND_STARS_COLOR = 0xc08efd;

// высота нижнего меню
export const SPACESHIP_BOTTOM_OFFSET = 140;

export const CLICK_WAVE_EMITTER_POOL_SIZE = 6;

export enum ClickerGameLayers {
  BackgroundLayer = 100,
  SpaceshipLayer = 200,
  BonusesLayer = 300,
  EmittersPoolLayer = 400,
}

export const CLICKS_COUNT_FOR_INTENSIVE_ANIMATION = 30;
export const CLICKS_COUNT_FOR_SHASHLYK_ANIMATION = 100;
export const RESET_TO_COMMON_CLICK_ANIMATION_TIME = 1500;
export const CLICK_ANIMATION_THROTTLE_TIME = 350;

export const SPACESHIP_ANIMATION_DURATION = 2000;
export const SPACESHIP_ANIMATION_EASING = 'easeInQuad';
export const SPACESHIP_ANIMATION_Y_SHIFT = 2;

export const SPACESHIP_FLASHLIGHT_ANIMATION_DURATION = 1500;
export const SPACESHIP_FLASHLIGHT_ANIMATION_DELAY = 3000;
export const SPACESHIP_FLASHLIGHT_ANIMATION_EASING = 'easeInQuad';

export const KOTLETKA_INACTIVE_TIME = 10000;

export const VIBRATE_TIME = 50;

export const HIDE_TIP_TAPS_COUNT = 5; // todo должно быть 5
export const MINING_TAPS_COUNT = 30; // должно быть 30
export const MANY_MINING_TAPS_COUNT = 200; // должно быть 200

export const STARS_ACCELERATION_MIN = 0.05;
export const STARS_ACCELERATION_MAX = 5;
export const STARS_ACCELERATION_MAX_TAPS = 50;

export const COMETA_EMITTER_CONFIG = (spawnPosition: Point2d, direction: DirectionConfig): ParticleEmitterConfig => ({
  emitterConfig: {
    spawnInterval: {
      min: COMETA_SPAWN_MIN_TIME,
      max: COMETA_SPAWN_MAX_TIME,
    },
    // spawnTimeout: COMETA_SPAWN_MIN_TIME,
    spawnChance: 35,
    autoStart: false,
  },
  particleConfig: {
    direction,
    speed: {
      value: 1,
      multiplier: {
        min: COMETA_MIN_SPEED,
        max: COMETA_MAX_SPEED,
      },
    },
    rotation: {
      value: 0,
      delta: 1,
    },
    spawnPosition: spawnPosition,
  },
});

export const ASTEROID_EMITTER_CONFIG = (spawnShape: SpawnShape): ParticleEmitterConfig => ({
  emitterConfig: {
    spawnInterval: {
      min: ASTEROID_SPAWN_MIN_TIME,
      max: ASTEROID_SPAWN_MAX_TIME,
    },
    spawnTimeout: ASTEROID_SPAWN_MIN_TIME,
    autoStart: false,
  },
  particleConfig: {
    direction: {
      angle: 90,
    },
    speed: {
      value: 1,
      multiplier: {
        min: ASTEROID_MIN_SPEED,
        max: ASTEROID_MAX_SPEED,
      },
    },
    rotation: {
      value: 0,
      delta: 1,
    },
    spawnShape: {
      shape: spawnShape,
    },
  },
});
